// src/components/NotificationListenerWrapper.jsx

'use client';

import NotificationActionsListener from './notification-listener';

export default function NotificationListenerWrapper() {
  const handleAccept = () => {
    // console.log('Call accepted!');
    // TODO: Add your accept logic here
  };

  const handleDecline = () => {
    // console.log('Call declined!');
    // TODO: Add your decline logic here
  };

  return <NotificationActionsListener onAccept={handleAccept} onDecline={handleDecline} />;
}
